import { Injectable } from "@angular/core";
import { NgbDateAdapter, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import moment from 'moment';

@Injectable()
export class CustomDateAdapter extends NgbDateAdapter<Date> {

    public fromModel(date: Date | null): NgbDateStruct | null {

        if(typeof date == 'string'){
            date = new Date(date);
        }

        return date ?
            { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() }
            : null;
    }

    public toModel(date: NgbDateStruct | null): Date | null {
        return date !== null && date.year !== null && date.month !== null
            ? new Date(date.year, date.month - 1, date.day + 1) 
            : null;
    }
}